import React from 'react';
// Presentational component
import { LanguageSwitch } from './LanguageSwitch';

export interface HeaderLanguageBarProps {
  /** Array of links: { text?: string; locale: string } */
  links: { text?: string; locale: string }[];
  /** Whether to show the language bar (computed by Header) */
  visible?: boolean;
}

export const HeaderLanguageBar: React.FC<HeaderLanguageBarProps> = (props) => {
  const { links = [], visible = false } = props;

  if (!visible || links.length === 0) {
    return null;
  }

  return <LanguageSwitch links={links} />;
};
